module.exports = __webpack_public_path__ + "static/img/iconfont.64229a0.svg";


//////////////////
// WEBPACK FOOTER
// ./static/icon/iconfont.svg?t=1541389109413
// module id = LI+X
// module chunks = 1